<ng-container *ngIf="item">
  <nz-radio-group
    [ngModel]="value"
    (ngModelChange)="onModelChange($event)"
    role="radiogroup"
    [nzName]="'radiogroup_' + item._elementId"
    attr.aria-labelledby="label-{{ item._elementId }}"
    (click)="lhcDataService.setActiveRow(item)">
    <label
      nz-radio
      [nzDisabled]="item._readOnly"
      [disabled]="item._readOnly"
      [nzValue]="true"
      [(ngModel)]="booleanModels[0]"
      [id]="lhcDataService.getItemAnswerId(item, 'true')"
      >{{language.booleanYes}}</label>
    <label
      nz-radio
      [nzDisabled]="item._readOnly"
      [disabled]="item._readOnly"
      [nzValue]="false"
      [(ngModel)]="booleanModels[1]"
      [id]="lhcDataService.getItemAnswerId(item, 'false')"
      >{{language.booleanNo}}</label>
    <label
      nz-radio
      [nzDisabled]="item._readOnly"
      [disabled]="item._readOnly"
      [nzValue]="null"
      [(ngModel)]="booleanModels[2]"
      [id]="lhcDataService.getItemAnswerId(item, 'null')"
      >{{language.booleanNotAnswered}}</label>
  </nz-radio-group>
</ng-container>
